import React from 'react';
import { FileUpload } from './FileUpload';
import { COLORS } from '../../../core/constants/colors';

interface UploadDocumentDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  companyId: number;
  onUploadComplete?: () => void;
}

export const UploadDocumentDrawer: React.FC<UploadDocumentDrawerProps> = ({
  isOpen,
  onClose,
  companyId,
  onUploadComplete,
}) => {
  if (!isOpen) return null;

  const handleUploadComplete = () => {
    if (onUploadComplete) {
      onUploadComplete();
    }
  };

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-50 transition-opacity"
        onClick={onClose}
      />
      
      {/* Side Drawer */}
      <div className="fixed right-0 top-0 h-full w-full max-w-md bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto">
        <div className="h-full flex flex-col">
          {/* Header */}
          <div className="px-6 py-5 border-b flex items-center justify-between flex-shrink-0" style={{ borderColor: '#E5E7EB' }}>
            <h2 className="text-xl font-bold" style={{ color: '#1F2937' }}>
              Upload Document
            </h2>
            <button
              onClick={onClose}
              className="w-8 h-8 rounded-lg flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-all"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Form Content */}
          <div className="flex-1 px-6 py-6 overflow-y-auto">
            <div>
              <label className="block text-sm font-medium mb-2" style={{ color: '#1F2937' }}>
                Upload Files
              </label>
              <FileUpload
                companyId={companyId}
                onUploadComplete={handleUploadComplete}
                acceptedTypes={['.pdf', '.docx', '.xlsx', '.txt', '.doc', '.xls', '.csv', '.pptx', '.png', '.jpg', '.jpeg']}
                maxFileSize={100}
              />
            </div>
          </div>

          {/* Footer */}
          <div className="px-6 py-4 border-t flex-shrink-0" style={{ borderColor: '#E5E7EB' }}>
            <button
              onClick={onClose}
              className="w-full py-2 px-4 rounded-lg font-medium text-white transition-all"
              style={{ backgroundColor: COLORS.user.queryButton }}
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

